import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Subscribes to realtime changes on public.profiles and invalidates
 * every React Query cache key that depends on client/profile data so
 * that edits made in Admin → Clientes propagate everywhere (Agendar,
 * Agendados, Calendário, Navbar, etc.) without touching historic
 * appointment records.
 */
export function useProfilesRealtime() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const channel = supabase
      .channel(`profiles-realtime-${Math.random().toString(36).slice(2)}`)
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'profiles' },
        () => {
          queryClient.invalidateQueries({ queryKey: ['admin-clients'] });
          queryClient.invalidateQueries({
            predicate: (q) => {
              const k = q.queryKey;
              if (!Array.isArray(k) || k.length === 0) return false;
              const head = String(k[0] ?? '');
              return (
                head === 'client-names-by-ids' ||
                head === 'navbar-profile' ||
                head.includes('profile')
              );
            },
          });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
}
